import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import useTitle from '../../../../utils/customHook/useTitle'
import { PATH_RPQS_REFERENCIAL_COLLECTIVITY } from '../../../../home/constants/RouteConstants'
import RpqsReferentialEventsApp from '../../events/RpqsReferentialEventsApp'

const CollectivityEventApp = () => {
    const { id } = useParams()

    const {
        collectivity,
    } = useSelector(store => ({
        collectivity: store.RpqsReducer.collectivity,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.rpqs,
        href: 'rpqs',
    }, {
        title: i18n.RPQSReferencials,
        href: 'rpqs/referencials',
    }, {
        title: i18n.collectivities,
        href: PATH_RPQS_REFERENCIAL_COLLECTIVITY,
    }, {
        title: collectivity?.name,
        href: `${PATH_RPQS_REFERENCIAL_COLLECTIVITY}${id}/dashboard`,
    }, {
        title: i18n.event,
        href: `${PATH_RPQS_REFERENCIAL_COLLECTIVITY}${id}/event`,
    }], [collectivity, id])

    return <RpqsReferentialEventsApp collectivityId={id} />
}

export default CollectivityEventApp
